import { Routes } from '@angular/router';

import { BlankComponent, FullComponent, WebsiteComponent } from '@app/shared';
import { AuthenticationGuard } from './core';
import { WebSiteComponent } from './web-site/web-site.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    // canActivate: [AuthenticationGuard],
    data: {
      // title: 'lista habitaciones',
      roles: ['administrador', 'super_admin', 'recepcion']
    },
    children: [
      {
        path: '',
        // redirectTo: '/dashboard',
        redirectTo: '/webSite',

        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./authentication/authentication.module').then(
            m => m.AuthenticationModule
          )
      }
    ]
  },
  {
    path: 'webSite',
    component: WebSiteComponent,
    // canActivate: [AuthenticationGuard],
    data: {
      // title: 'lista habitaciones',
      roles: ['administrador', 'super_admin', 'recepcion']
    }
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];
